import defineMessages from "../../../common/helpers/defineMessages";

const messages = defineMessages({
    retry: {
        id: "error.retry",
    },
});

export default messages;
